import { render, staticRenderFns } from "./VoyageDataCarousel.vue?vue&type=template&id=2f7f5f12&scoped=true&"
import script from "./VoyageDataCarousel.vue?vue&type=script&lang=js&"
export * from "./VoyageDataCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VoyageDataCarousel.vue?vue&type=style&index=0&id=2f7f5f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f5f12",
  null
  
)

export default component.exports